
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-online/[...slug]",
      function () {
        return require("private-next-pages/help-online/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-online/[...slug]"])
      });
    }
  